import axios from "axios";

export default function updateLeaseTemplate({ id, data, formData, jwt }) {
  return new Promise((resolve, reject) => {
    const backend_url = process.env.REACT_APP_BACKEND_URL;
    const isMultipart = Boolean(formData);
    axios({
      url: `${backend_url}/lease-templates/${id}`,
      method: "PUT",
      data: isMultipart ? formData : data,
      headers: {
        Authorization: `Bearer ${jwt}`,
        ...(isMultipart
          ? { "Content-Type": "multipart/form-data" }
          : { "Content-Type": "application/json" }),
      },
    })
      .then((res) =>
        resolve({
          data: res.data,
          error: false,
          complete: true,
        })
      )
      .catch((e) => {
        reject({
          data: null,
          error: true,
          errorMessage: e.response ? e.response.data : e,
          complete: true,
        });
      });
  });
}
